export default function AnimatedToggleArrow() {
	return (
		<div className="border-brown-middle relative h-[2.5rem] w-[6rem] animate-[backgroundToggle_5s_infinite] overflow-hidden rounded-full border-2 bg-white sm:h-[3.625rem] sm:w-[8.75rem]">
			<div className="bg-brown-middle absolute -top-0.5 z-1 flex h-[2.55rem] w-[2.55rem] animate-[moveThumb-mobile_5s_infinite] items-center justify-center rounded-full text-lg text-white sm:h-[3.75rem] sm:w-[3.75rem] sm:animate-[moveThumb-desktop_5s_infinite]">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 36 36"
					fill="none"
					className="sm:h-[2.188rem] sm:w-[2.188rem]"
				>
					<path
						d="M18.5891 34.3092C18.0008 34.8975 17.0464 34.8975 16.4581 34.3092C15.87 33.7209 15.8706 32.7671 16.4588 32.1789L25.4033 23.2345C25.6455 22.9923 25.8692 22.7387 26.0745 22.4754C27.3975 20.7789 25.7426 18.755 23.5912 18.755L8.40988 18.755C7.57808 18.7549 6.904 18.0807 6.90382 17.2489C6.90382 16.4169 7.57857 15.7422 8.41058 15.7422H23.2852C25.5118 15.7422 27.1547 13.5842 25.649 11.9438C25.5695 11.8572 25.4879 11.772 25.404 11.6881L17.1072 3.39137C16.5193 2.80309 16.5191 1.84992 17.1072 1.26177C17.6955 0.673508 18.6499 0.673509 19.2382 1.26177L34.6344 16.6578C35.0602 17.0837 35.0602 17.7746 34.6344 18.2005C34.5723 18.2626 34.5195 18.3331 34.468 18.4042C34.4234 18.4658 34.3736 18.5248 34.3181 18.5803L18.5891 34.3092Z"
						fill="#504120"
					/>
					<rect
						width="3.01295"
						height="24.3964"
						transform="matrix(-0.70711 -0.707104 0.70711 -0.707104 17.5234 35.3672)"
						fill="#504120"
					/>
					<rect
						width="3.01295"
						height="24.2785"
						transform="matrix(0.70711 -0.707104 0.70711 0.707104 16.0469 2.32031)"
						fill="#504120"
					/>
					<rect x="30.7891" y="15.7422" width="3.01294" height="26.2288" transform="rotate(90 30.7891 15.7422)" fill="#504120" />
				</svg>
			</div>
		</div>
	);
}
